import { isErrorResponse, getCaptchaHeader } from '@standardnotes/responses';
import { AbstractService } from '../Service/AbstractService';
export class AuthManager extends AbstractService {
    constructor(authApiService, internalEventBus) {
        super(internalEventBus);
        this.authApiService = authApiService;
        this.internalEventBus = internalEventBus;
    }
    async generateRecoveryCodes(dto) {
        try {
            const result = await this.authApiService.generateRecoveryCodes(dto);
            if (isErrorResponse(result)) {
                return false;
            }
            return result.data.recoveryCodes;
        }
        catch {
            return false;
        }
    }
    async recoveryKeyParams(dto) {
        try {
            const result = await this.authApiService.recoveryKeyParams(dto);
            if (isErrorResponse(result)) {
                return false;
            }
            return result.data.keyParams;
        }
        catch {
            return false;
        }
    }
    async signInWithRecoveryCodes(dto) {
        try {
            const result = await this.authApiService.signInWithRecoveryCodes(dto);
            const captchaURL = getCaptchaHeader(result);
            if (captchaURL) {
                return {
                    success: false,
                    captchaURL,
                };
            }
            if (isErrorResponse(result)) {
                return {
                    success: false,
                    captchaURL: '',
                };
            }
            return {
                success: true,
                keyParams: result.data.key_params,
                session: result.data.session,
                user: result.data.user,
            };
        }
        catch {
            return {
                success: false,
                captchaURL: '',
            };
        }
    }
}
